import React, { useContext } from 'react';

import VisibilityOptions from 'ui/VisibilityOptions';
import { DetailViewContext } from 'providers';
import {
  DEFAULT_DETAILS_FIELD_VISIBILITY,
  DISABLED_DETAILS_FIELD_VISIBILITY,
} from 'constants/details';

const ItemDetailsOptions = () => {
  const { visibleFields, handleVisibleFieldsChange } =
    useContext(DetailViewContext);

  return (
    <VisibilityOptions
      defaultOptions={DEFAULT_DETAILS_FIELD_VISIBILITY}
      disabledOptions={DISABLED_DETAILS_FIELD_VISIBILITY}
      selectedOptions={visibleFields}
      onSelectedOptionsChange={handleVisibleFieldsChange}
    />
  );
};

export default ItemDetailsOptions;
